import type { ChangeLogResponse } from './changelog.api.types';

// The feed serves `access-control-allow-origin: *`, so it can be fetched directly
// cross-origin from local dev — no proxy needed.
const insideTimelyFeedUrl = 'https://www.timely.com/inside-timely/feed.json';

const changelogApi = {
  /***
   * API for retrieving the latest Inside Timely entries.
   * @param _lastReadUpdates Deprecated; unread state is derived client-side from user properties.
   */
  getReleaseNotes: async (_lastReadUpdates?: string): Promise<ChangeLogResponse | undefined> => {
    try {
      const result = await fetch(insideTimelyFeedUrl);
      if (!result.ok) return;
      const parsed = await result.json();
      return parsed as ChangeLogResponse;
    } catch {}
  },
};

export default changelogApi;
